export default {
  methods: {
    capValue(prefix, val) {
      return `${prefix ? prefix + ':' : ''}${val >= 0 ? val : 'U'}`;
    },
  },
};
